import { render, staticRenderFns } from "./document-resources.vue?vue&type=template&id=43d52e18&scoped=true"
import script from "./document-resources.vue?vue&type=script&lang=js"
export * from "./document-resources.vue?vue&type=script&lang=js"
import style0 from "./document-resources.vue?vue&type=style&index=0&id=43d52e18&prod&scoped=true&lang=css"
import style1 from "./document-resources.vue?vue&type=style&index=1&id=43d52e18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d52e18",
  null
  
)

export default component.exports